import { makeObservable, action } from "mobx";
import { Quote } from '../api';

export default class QuoteStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      getQuote: action,
      updateQuoteById: action
    });
  }

  async getQuote() {
    try {
      const retObj = await Quote.getQuotes();
      return retObj.data.response.quotes;
    } catch (error) {
      console.error("Error in getQuote:", error);
      throw error;
    }
  }

  async updateQuoteById(id, data) {
    try {
      const retObj = await Quote.updateQuoteById(id, data);
      return retObj.data.response.quote;
    } catch (error) {
      console.error("Error in updateQuoteById:", error);
      throw error;
    }
  }
}
